import { isRTL } from "src/utils/global";
import { ToastOptions } from "react-toastify";

export const toastOptions: ToastOptions = {
    rtl: isRTL(),
    style: { width: "fit-content" },
    position: isRTL() ? "bottom-right" : "bottom-left",
    autoClose: false,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: false,
    draggable: false,
    progress: undefined,
    theme: "light",
};